import React from "react";
import BAYC from '../assets/BAYC.png'
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div name="home" className="h-screen w-full bg-gradient-to-b from-black via-black to-gray-800 text-white">

      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
        <div className="flex flex-col justify-center h-full">
          <h2 className="text-4xl sm:text-7xl font-bold text-white">I'm a Front End Developer</h2>
          <p className="text-gray-500 py-4 ">
            Hello there! I'm Pratik aka Rio and I have done my Engineering from Coochbehar Government Engineering
            College or better known as CGEC. I've been a Tech-enthuasiast since
            my childhood. From reverse engineering my video game at age 10 to
            building websites from my early 20s, I'm always keen to learn something new. Hope this describes my journey in a Nutshell. 
          </p>
          <div>
            <Link to="portfolio" smooth duration={500} className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer">
                Portfolio
                <span className="group-hover:rotate-90 duration-300">
                <MdOutlineKeyboardArrowRight size={25} className="ml-1"  />
                </span>
            </Link>
          </div>
        </div>
      <div>
      <img src={BAYC} alt="my Profile" 
        className="rounded-2xl mx-auto w-1/3 md:w-full"
      />
          </div>
        </div>
    </div>
  );
};

export default Home;
